import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import "./Plans.css";
import { Context } from "../../../context/Context";
import { landingContent } from "../content/landingContent";

export const Plans = () => {
  const { lang } = useContext(Context);
  const t = landingContent[lang] || landingContent.en;

  return (
    <section className="landing-plans-section" id="plans">
      <div className="landing-section-title">
        <h2>{t.plans.title}</h2>
        <p className="landing-plans-note">{t.plans.note}</p>
        <p>{t.plans.subtitle}</p>
      </div>

      <div className="landing-plans">
        {t.plans.items.map((plan) => (
          <article
            className={`landing-plan ${plan.featured ? "featured" : ""}`}
            key={plan.code}
          >
            <div className="landing-plan-code">{plan.code}</div>
            <h3>{plan.name}</h3>
            <div className="landing-plan-price">
              <strong>{plan.price}</strong> <span>{t.plans.currency}</span>
            </div>
            <div className="landing-plan-branch">{plan.branchNote}</div>
            <ul>
              {plan.features.map((f) => (
                <li key={f}>
                  <Check size={14} />
                  {f}
                </li>
              ))}
            </ul>
            <Link to="/contactus" className="landing-btn landing-plan-cta">
              {t.hero.start}
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Plans;
